import React from 'react';
import PropTypes from 'prop-types';
import Ellipsis from 'components/Ellipsis';
import StyledText from './styled-wrapper';
import resolveDescriptionContent from './content-resolver';

export default description;

description.propTypes = {
  isAvailable: PropTypes.bool,
  hasTVOD: PropTypes.bool,
  hasSVOD: PropTypes.bool,
  hasTDO: PropTypes.bool,
  translate: PropTypes.func,
  movie: PropTypes.object,
  subscriptionInfo: PropTypes.object,
};

function description(props) {
  const content = resolveDescriptionContent(props);

  return (
    <StyledText size="fs_s">
      <Ellipsis dangerouslySetInnerHTML={{ __html: content }} />
    </StyledText>
  );
}
